import useUniqueId from 'react-utils/hooks/useUniqueId';
import iconData from './iconData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Product tier icon for each hub.
 */
export default function ProductTierIcon({
  tier
}) {
  const id = useUniqueId(`${tier}-icon-`);
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15",
    height: "16",
    fill: "none",
    role: "img",
    "aria-hidden": true,
    children: [/*#__PURE__*/_jsx("path", {
      fill: `url(#${id}-a)`,
      d: "M.46 0h13.947v16H.46z"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsx("pattern", {
        id: `${id}-a`,
        width: "1",
        height: "1",
        patternContentUnits: "objectBoundingBox",
        children: /*#__PURE__*/_jsx("use", {
          xlinkHref: `#${id}-b`,
          transform: "matrix(.0012 0 0 .00104 -.074 0)"
        })
      }), /*#__PURE__*/_jsx("image", {
        id: `${id}-b`,
        xlinkHref: iconData[tier],
        width: "960",
        height: "960"
      })]
    })]
  });
}